import React from 'react'
import PropTypes from 'prop-types'
import StarCircleIcon from './icons/basic/star-circle-icon'

const propTypes = {
  iconUrl: PropTypes.string,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.number,
}

const defaultProps = {
  iconUrl: null,
  className: '',
}

/**
 * A generic badge indicator component that renders a dynamic badge
 * with an optional icon (loaded from URL) and a text label.
 * Replaces hardcoded indicator components (VendorIndicator,
 * OpenToEmploymentIndicator, LookingForArtistIndicator, etc.)
 */
function BadgeIndicator({ iconUrl, label, className, size }) {
  return (
    <div className={`flex-horizontal open-to-partnerships ${className}`}>
      <div className="badge-indicator-icon">
        {iconUrl ? (
          <img
            src={iconUrl}
            alt=""
            aria-hidden="true"
            style={{ width: size, height: size }}
          />
        ) : (
          <StarCircleIcon size={size} fill="#1B6DC1" aria-hidden="true" />
        )}
      </div>
      <p>
        <strong>{label}</strong>
      </p>
    </div>
  )
}

BadgeIndicator.propTypes = propTypes
BadgeIndicator.defaultProps = defaultProps

export default React.memo(BadgeIndicator)
